import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import SecureRoute from "shared/services/AuthDecorator/SecureRoute";

import { routes } from "./constants";

const BasicLayout = lazy(() => import("shared/templates/Layouts/BasicLayout"));

const LoginPage = lazy(() => import("./Pages/Login"));

const AuthRoutes = () => {
	const getPublicRoutes = () => [
		<Route
			key={routes.auth.login.getElementKey()}
			path={routes.auth.login.getPath()}
			element={
				<Suspense>
					<LoginPage />
				</Suspense>
			}
		/>
	];

	const getSecuredRoutes = () => [];

	return [
		<Route
			key="auth-routes-root"
			path={routes.auth.getPath()}
			element={
				<Suspense>
					<BasicLayout />
				</Suspense>
			}
		>
			{getPublicRoutes()}
			<Route element={<SecureRoute roles={[]} />}>{getSecuredRoutes()}</Route>
		</Route>
	];
};

export default AuthRoutes;
